import { useEffect, useRef } from 'react';

/**
 * useInterval
 *
 * A declarative setInterval wrapper. Automatically clears the interval
 * on unmount and pauses when `delay` is null.
 *
 * @param {Function} callback - Function to call on each interval tick
 * @param {number|null} delay - Interval in ms, or null to pause
 */
function useInterval(callback, delay) {
    const savedCallback = useRef(callback);

    // Update the ref each render so the interval always calls the latest callback
    useEffect(() => {
        savedCallback.current = callback;
    });

    useEffect(() => {
        if (delay === null) {
            return undefined;
        }

        const id = setInterval(() => savedCallback.current(), delay);
        return () => clearInterval(id);
    }, [delay]);
}

export { useInterval };
